// ProductFormFields.js
import React from 'react';
import {
  Box,
  Typography,
  Paper,
  FormControlLabel,
  Checkbox,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
} from '@mui/material';
import { TextInput, required } from 'react-admin';
import { useFormContext, Controller } from 'react-hook-form';

const ProductFormFields = ({ allConfigs, allRecipes }) => {
  const { control } = useFormContext();

  return (
    <>
      <TextInput source="Name" validate={required()} fullWidth />

      {/* Config dropdown */}
      <Controller
        name="Config"
        control={control}
        defaultValue=""
        render={({ field }) => (
          <FormControl fullWidth margin="normal">
            <InputLabel id="config-select-label">Configuração</InputLabel>
            <Select
              labelId="config-select-label"
              label="Configuração"
              {...field}
            >
              {allConfigs.map((config) => (
                <MenuItem key={config.id} value={config.id}>
                  {config.Name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
      />

      {/* Recipes checkbox list */}
      <Controller
        name="Recipes"
        control={control}
        defaultValue={[]}
        render={({ field }) => (
          <Box mt={2}>
            <Typography variant="h6">Receitas disponíveis:</Typography>
            {allRecipes.map((recipe) => (
              <FormControlLabel
                key={recipe.id}
                control={
                  <Checkbox
                    checked={field.value.includes(recipe.id)}
                    onChange={() => {
                      const newValue = field.value.includes(recipe.id)
                        ? field.value.filter((r) => r !== recipe.id)
                        : [...field.value, recipe.id];
                      field.onChange(newValue);
                    }}
                  />
                }
                label={recipe.Name}
              />
            ))}

            {/* Preview */}
            {field.value.length > 0 && (
              <Box mt={2}>
                <Typography variant="h6" gutterBottom>Receitas selecionadas:</Typography>
                {field.value.map((id) => {
                  const recipe = allRecipes.find((r) => r.id === id);
                  return recipe ? (
                    <Paper key={id} variant="outlined" sx={{ mb: 1, p: 1 }}>
                      <Typography variant="body1">{recipe.Name}</Typography>
                    </Paper>
                  ) : null;
                })}
              </Box>
            )}
          </Box>
        )}
      />
    </>
  );
};

export default ProductFormFields;
